export default "__VITE_ASSET__CACp42Rk__"